export enum LoginTypes {
    EMPLOYEE = 'Employee',
    STUDENT = 'Student',
    PARENT = 'Parent',
    RECTOR = 'Rector',
    OTHER = 'Other',
}
